<script>
  import { MajorColor, ModerateColor, MinorColor, ActionColor, RecordColor, LowColor } from './theme.js'
  import { MissingFloat } from '../../common/ahps.js'
  import { definitionState } from './store.js'

  // flood is the API gaugeFlood model.
  export let assetURL
  export let flood
  export let floodCatUnits

  // Get
  let floodCatUnit =
    floodCatUnits.options != null && floodCatUnits.options.find(({ id }) => id == floodCatUnits.value).value
  let fcu = floodCatUnit != 'ft' ? floodCatUnit : 'cfs'

  let showDefinition = assetURL + 'images/chevron-down.svg'
  let hideDefinition = assetURL + 'images/chevron-right.svg'

  const stages = []

  // This probably something that will be determined by a CMS value and added
  // to the API response for a gauge, but for now we'll just check that each
  // value is not missing.
  if (flood && flood.major && flood.major.stage > MissingFloat) {
    stages.push({
      category: 'Major',
      categoryTitle: 'Major Flooding',
      stageValue: flood.major.stage > MissingFloat ? flood.major.stage : '',
      flowValue: flood.major.flow[fcu] > MissingFloat ? flood.major.flow[fcu] : '',

      stageUnits: flood.major.stage > MissingFloat ? floodCatUnit : '',
      flowUnits: flood.major.flow[fcu] > MissingFloat ? floodCatUnit : '',
      definition:
        'Extensive inundation of structures and roads. Significant evacuations of people and/or transfer of property to higher elevations.',
      color: MajorColor,
    })
  }
  if (flood && flood.moderate && flood.moderate.stage > MissingFloat) {
    stages.push({
      category: 'Moderate',
      categoryTitle: 'Moderate Flooding',
      stageValue: flood.moderate.stage > MissingFloat ? flood.moderate.stage : '',
      flowValue: flood.moderate.flow[fcu] > MissingFloat ? flood.moderate.flow[fcu] : '',

      stageUnits: flood.moderate.stage > MissingFloat ? floodCatUnit : '',
      flowUnits: flood.moderate.flow[fcu] > MissingFloat ? floodCatUnit : '',
      definition: 'Some inundation of structures and roads near stream.',
      color: ModerateColor,
    })
  }
  if (flood && flood.minor && flood.minor.stage > MissingFloat) {
    stages.push({
      category: 'Minor',
      categoryTitle: 'Minor Flooding',
      stageValue: flood.minor.stage > MissingFloat ? flood.minor.stage : '',
      flowValue: flood.minor.flow[fcu] > MissingFloat ? flood.minor.flow[fcu] : '',

      stageUnits: flood.minor.stage > MissingFloat ? floodCatUnit : '',
      flowUnits: flood.minor.flow[fcu] > MissingFloat ? floodCatUnit : '',
      definition: 'Minimal or no property damage, but possibly some public threat.',
      color: MinorColor,
    })
  }
  if (flood && flood.low && flood.low.stage > MissingFloat) {
    stages.push({
      category: 'Low',
      categoryTitle: 'Low Water Level',
      stageValue: flood.low.stage > MissingFloat ? flood.low.stage : '',
      flowValue: flood.low.flow[fcu] > MissingFloat ? flood.low.flow[fcu] : '',

      stageUnits: flood.low.stage > MissingFloat ? floodCatUnit : '',
      flowUnits: flood.minor.flow[fcu] > MissingFloat ? floodCatUnit : '',
      definition: 'Low Water record level is happening now.',
      color: LowColor,
    })
  }
  if (flood && flood.action && flood.action.stage > MissingFloat) {
    stages.push({
      category: 'Action',
      categoryTitle: 'Action',
      stageValue: flood.action.stage > MissingFloat ? flood.action.stage : '',
      flowValue: flood.action.flow[fcu] > MissingFloat ? flood.action.flow[fcu] : '',

      stageUnits: flood.action.stage > MissingFloat ? floodCatUnit : '',
      flowUnits: flood.action.flow[fcu] > MissingFloat ? floodCatUnit : '',
      definition:
        'The level which, when reached by a rising stream, represents the level where the NWS or a customer/partner needs to take some type of mitigation action in preparation for possible significant hydrologic activity.',
      color: ActionColor,
    })
  }
  if (flood && flood.record && flood.record.stage > MissingFloat) {
    stages.push({
      category: 'Record',
      categoryTitle: 'Record Flood Level',
      stageValue: flood.record.stage > MissingFloat ? flood.record.stage : '',
      flowValue: flood.record.flow[fcu] > MissingFloat ? flood.record.flow[fcu] : '',

      stageUnits: flood.record.stage > MissingFloat ? floodCatUnit : '',
      flowUnits: flood.record.flow[fcu] > MissingFloat ? floodCatUnit : '',
      definition: 'Record flood level is happening now.',
      color: RecordColor,
    })
  }

  // Show and hide the flood category definitions below each level
  // Svelte-table based accordion by Matthew Schmidt
  function showHide(category) {
    $definitionState[category] = !$definitionState[category]
  }
</script>

{#if stages.length > 0}
  <table class="uk-table uk-table-divider">
    <thead>
      <tr class="font-size-13 headings" style="background: #F0F0F0;">
        <th class="header" aria-label="flood categories table" />
        <th class="header bold-black">CATEGORY</th>
        {#if floodCatUnit == 'ft'}
          <th class="header bold-black">STAGE</th>
        {:else}
          <th class="header bold-black">FLOW</th>
        {/if}
      </tr>
    </thead>
    <tbody>
      {#each stages as s}
        <tr class="font-size-13" style="background: rgba({s.color}, 0.1);">
          <td class="color" style="background: rgb({s.color});">
            <button
              style="background-image: url({$definitionState[s.category] == true
                ? showDefinition
                : hideDefinition}); height: 20px; width: 20px; border: none; background-color:  rgb({s.color});"
              on:click={() => showHide(s.category)}
              aria-label={`Toggle open ${s.category.toLowerCase()} category`}
            />
          </td>
          <td class="category uk-text-bold">{s.categoryTitle}</td>
          {#if floodCatUnit == 'ft'}
            <td class="uk-text-bold">{s.stageValue} {s.stageUnits}</td>
          {:else}
            <!-- TODO: this is not 100% accurate and needs to account for both CFS and KCFS settings.
            {#if s.flowValue && s.flowValue > MissingFloat} -->
            <td class="uk-text-bold">{s.flowValue} {s.flowUnits}</td>
            <!-- {:else}
            <td class="uk-text-bold" />
          {/if} -->
          {/if}
        </tr>
        {#if $definitionState[s.category]}
          <tr style="background: rgba({s.color}, 0.1);">
            <td class="color" style="background: rgb({s.color});" />
            <td colspan="3" class="category-font-size category uk-text-italic">{s.definition}</td>
          </tr>
        {/if}
      {/each}
    </tbody>
  </table>
{/if}

<style>
  /* td {
    padding: 6px 0 6px 0;
  }
  .color {
    width: 8px;
  }
  .category {
    padding-left: 10px;
  }
  .category-font-size {
    font-size: 11px;
  }
  .bold-black {
    color: #000000;
    font-weight: bold;
  } */

  table {
    /* Prevents the table from forcing the max-height of all child elements to match grid height. */
    max-height: 110px;
  }
  td {
    padding: 0;
    vertical-align: middle;
  }
  th {
    padding: 0;
    color: #6b6b6b;
  }
  .color {
    width: 20px;
  }
  .category {
    padding-left: 5px;
  }
</style>
